/**
 * Detects if the current device is a smartphone (not a tablet).
 * Tablets (iPad, Android tablets) return false.
 * Used by SmartphoneRedirect (App.tsx) and area chooser flow (Index.tsx).
 * @returns true for iPhone, Android Mobile, Windows Phone, BlackBerry; false for iPad/Android tablets and desktop.
 */
export const isSmartphone = (): boolean => {
  const ua = navigator.userAgent;
  return /iPhone|Android.*Mobile|Windows Phone|BlackBerry/i.test(ua) &&
    !/iPad|Android(?!.*Mobile)/i.test(ua);
};
